export default {
  data() {
    return {
      contactForwardEmailList: [],
      signatureList: [],
      senderList: [],
    };
  },
  created() {
    this.getcontactForwardEmailList();
  },
  computed: {
    signatureIndex() {
      return this.signatureList.find(
        (e) =>
          e.ticket_email_plugin_id == this?.replyForm?.ticket_email_plugin_id ||
          e.ticket_email_plugin_id == this.form.ticket_email_plugin_id
      );
    },
  },
  methods: {
    async getTicketConnection() {
      if (this.senderList.length) return;
      const res = await this.axios(`/ticket/ticketemailplugin`);

      this.senderList = res.data.detail;
    },
    async getcontactForwardEmailList() {
      const res = await this.axios.get(`/setting/listemail`);
      if (res.data.result == 1) {
        this.contactForwardEmailList = res.data.detail;
      } else {
        this.errorAlert(res.data.message);
      }
    },
    sanitize(html = "") {
      return String(html)
        .replace(/<\s*(script|style|iframe)\b[^>]*>[\s\S]*?<\s*\/\1\s*>/gi, "")
        .replace(/\son\w+="[^"]*"/gi, "")
        .replace(/\son\w+='[^']*'/gi, "");
    },
    textToHtml(text = "") {
      return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br/>");
    },
    formatSentLine(date) {
      // ตัวอย่าง: Mon, 18 Aug 2025 10:23 +0700
      return this.$moment(date).format("ddd, DD MMM YYYY HH:mm Z");
    },
    resolveItem(items) {
      if (items) return items;
      if (this.items.length === 0) return this.ticketDetail.ticket || null;
      const lastest_ticket = this.items.find(
        (el) => el.id == this.lastest_activity_id
      );
      return lastest_ticket || null;
    },

    buildOutlookForwardHeader(resolved) {
      const fromName = resolved?.name_created
        ? this.sanitize(resolved.name_created)
        : "";
      const fromEmail = resolved?.email_forward
        ? this.sanitize(resolved.email_forward)
        : "";
      const sent = resolved?.created_time
        ? this.formatSentLine(resolved.created_time)
        : "";
      const toLine = resolved?.email_to ? this.sanitize(resolved.email_to) : "";
      const ccLine = resolved?.email_cc ? this.sanitize(resolved.email_cc) : "";
      const subject = resolved?.email_subject
        ? this.sanitize(resolved.email_subject)
        : "";

      const rows = [
        fromName || fromEmail
          ? `<p style="margin:2px 0;"><b>From:</b> ${fromName}${
              fromEmail ? ` &lt;${fromEmail}&gt;` : ""
            }</p>`
          : "",
        sent ? `<p style="margin:2px 0;"><b>Sent:</b> ${sent}</p>` : "",
        toLine ? `<p style="margin:2px 0;"><b>To:</b> ${toLine}</p>` : "",
        ccLine ? `<p style="margin:2px 0;"><b>Cc:</b> ${ccLine}</p>` : "",
        subject
          ? `<p style="margin:2px 0;"><b>Subject:</b> ${subject}</p>`
          : "",
      ]
        .filter(Boolean)
        .join("");

      return `
        <div class="OutlookMessageHeader" style="margin:0 0 8px;">
          ${rows}
        </div>
      `;
    },

    buildNoteBlock(resolved) {
      let _noted = resolved.note || resolved?.ticket_detail || "";

      const note = _noted
        ? _noted.includes("<")
          ? this.sanitize(_noted)
          : this.textToHtml(_noted)
        : "";

      const ref = resolved?.ref_note
        ? resolved.ref_note.includes("<")
          ? this.sanitize(resolved.ref_note)
          : this.textToHtml(resolved.ref_note)
        : "";
      const refBlock = ref
        ? `<blockquote type="cite" style="margin:8px 0 0; padding-left:12px; border-left:3px solid #ddd;">${ref}</blockquote>`
        : "";
      return `<div>${note}</div>${refBlock}`;
    },

    buildQuotedShell({ title, headerHtml, bodyHtml }) {
      const titleHtml = title
        ? `<p style="font-weight:bold; font-size:14px; margin:0 0 8px;">${title}</p>`
        : "";

      return `<p></p><p class="rte-guard" contenteditable="false" aria-hidden="true"><span data-rte-keeper="1" contenteditable="false" aria-hidden="true">&#65279;</span></p>
    <div class="gmail_quote protected-quote"
         contenteditable="false"
         data-rte-protected="1">
      <hr style="border:none;border-top:1px solid #eee; margin:16px 0;"/>
      <blockquote type="cite"
                  style="margin:0; padding-left:12px; border-left:3px solid #ddd;">
        ${titleHtml}
        ${headerHtml}
        ${bodyHtml}
      </blockquote>
    </div>
    <p class="rte-guard-after" contenteditable="false" aria-hidden="true">
      <span data-rte-keeper="1" contenteditable="false" aria-hidden="true">&#65279;</span>
    </p><div></div>`;
    },

    async buildForwardBody(items) {
      const resolved = this.resolveItem(items);

      if (!resolved) return "";

      await this.$nextTick();
      this.$bus.$emit(
        "addEditorFile",
        ...resolved.attach_file.map((el) => ({
          name: el.fileName,
          path: el.path,
        }))
      );
      // const headerOutlook = this.buildOutlookForwardHeader(resolved);
      const sent = resolved?.created_time
        ? this.formatSentLine(resolved.created_time)
        : "";
      const who = resolved?.name_created
        ? this.sanitize(resolved.name_created)
        : this.userProfile.name;
      const whoLine = `<p style="margin:0 0 8px;">On ${sent}, ${who} wrote:</p>`;
      const bodyHtml = this.buildNoteBlock(resolved);

      const quoted = this.buildQuotedShell({
        title: "",
        headerHtml: whoLine,
        bodyHtml,
      });

      // const emlString = this.buildEml({
      //   from: "Sale Dosetech <dosetech.sale@dosetechsaleoutlook.onmicrosoft.com>",
      //   to: "phaka.th@outlook.com",
      //   subject: "test",
      //   html: bodyHtml,
      // });
      // console.log(emlString, "emlString");

      // this.forwardEmail(this.toBase64(emlString));

      return `<div>${quoted}</div>`;
    },

    buildReplyBody(items) {
      const resolved = this.resolveItem(items);

      if (!resolved) return "";

      const sent = resolved?.created_time
        ? this.formatSentLine(resolved.created_time)
        : "";
      const who = resolved?.name_created
        ? this.sanitize(resolved.name_created)
        : this.userProfile.name;
      const whoLine = `<p style="margin:0 0 8px;">On ${sent}, ${who} wrote:</p>`;
      const bodyHtml = this.buildNoteBlock(resolved);

      const quoted = this.buildQuotedShell({
        title: "",
        headerHtml: whoLine,
        bodyHtml,
      });

      return `<div>${quoted}</div>`;
    },
    async forwardEmail(string) {
      let payload = {
        Base64String: this.toBase64(string),
        is_video: false,
        is_file: true,
        type: 1,
        file_name: "old_email_forward.eml",
      };
      const result = await this.axios.post("/news/UploadFile", payload);
      this.$bus.$emit("hideLoading");
      this.fileAttach = [
        {
          name: payload.file_name,
          path: result.data.detail,
        },
      ];
    },
    async setSignature(body = this.replyForm?.body || this.form?.body) {
      const newSignature = `<div class='signature-ticket'>${this.signatureIndex?.description}</div>`;
      const htmlWithSignature = this.replaceLastSignature(body, newSignature);
      this.$refs.replyBox?.updateModalValue(htmlWithSignature);
    },
    replaceLastSignature(htmlString, newSignatureHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const signatures = doc.querySelectorAll(".signature-ticket");

      if (signatures.length > 0) {
        signatures[signatures.length - 1].remove();
      }

      const wrapper = doc.createElement("div");
      wrapper.innerHTML = newSignatureHtml;

      doc.body.appendChild(wrapper.firstElementChild);

      return doc.body.innerHTML;
    },
    async getSignatureEmail() {
      if (this.signatureList.length > 0) return;
      const res = await this.axios("/setting/Get/Email/Signature");

      this.signatureList = res.data.detail;
    },
  },
};
